import React, {
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useRef,
} from "react";
import { Card, Col, Form, InputGroup, Row, Spinner } from "react-bootstrap";
import moment from "moment-timezone";
import api from "../../api";
import SrlChargerGraphSummary from "./SrlChargerGraphSummary";
import SrlChargerGraphTimeLine from "./SrlChargerGraphTimeLine";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Calendar } from "react-feather";
import NotyfContext from "../../contexts/NotyfContext";
import axios from "axios";

const GraphWidgetContainer = (props) => {
  const { children, title } = props;
  return (
    <>
      <Col lg={(0.5 * 12).toFixed(0)} className="p-1 m-0 d-flex flex-column">
        <Card
          // className="border flex-grow-1 b-0 m-0 my-1 p-0"
          // className="flex-grow-1 m-3 p-0"
          style={{
            height: "470px",
            minHeight: "470px",
            overflow: "auto",
          }}
        >
          <Card.Header className="p-3 pb-0">
            <Card.Title>{title}</Card.Title>
          </Card.Header>
          <Card.Body className="px-3">{children}</Card.Body>
        </Card>
      </Col>
    </>
  );
};

const SrlChargerGraphs = (props) => {
  const { charger } = props;

  // const [params, setParams] = useState({
  //   startDate: moment().subtract(1, "day"),
  //   endDate: moment(),
  // });
  // const [data, setData] = useState({});
  // const [loading, setLoading] = useState(0);
  // const [abortController, setAbortController] = useState();
  // const [unmounting, setUnmounting] = useState(false);

  const abortControllerRef = useRef(null);
  const requestIdRef = useRef(0);

  const notify = useContext(NotyfContext);

  const reducer = useCallback((state, action) => {
    const { type, data } = action;
    switch (type) {
      case "mount":
        return {
          ...state,
          mounted: true,
        };

      case "unmount":
        if (abortControllerRef.current) {
          abortControllerRef.current.abort();
        }
        return {
          ...state,
          mounted: false,
        };

      case "loading":
        return { ...state, loading: true };

      case "idle":
        return { ...state, loading: false };

      case "setDateRange":
        return { ...state, ...data };

      case "setData":
        return { ...state, data: data };

      default:
        return state;
    }
  });

  const [state, dispatch] = useReducer(reducer, {
    charger: charger,
    startDate: moment().subtract(1, "day"),
    endDate: moment(),
    abortController: null,
    mounted: false,
    data: null,
    loading: false,
    // getCount: 0,
  });

  const getChargerInfo = (state) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();

    const requestId = ++requestIdRef.current;
    dispatch({ type: "loading" });
    api
      .get(`solarchargers/${charger.id}/statistics`, {
        signal: abortControllerRef.current.signal,
        params: {
          start: state.startDate.utc().format(),
          end: state.endDate.utc().format(),
        },
      })
      .then((r) => {
        dispatch({ type: "setData", data: r.data || null });
      })
      .catch((reason) => {
        if (!axios.isCancel(reason)) {
          notify.open({
            type: "error",
            message: "Failed to load statistics",
          });
          dispatch({ type: "setData", data: null });
        }
      })
      .finally(() => {
        if (requestId === requestIdRef.current) {
          abortControllerRef.current = null;
          dispatch({ type: "idle" });
        }
      });
  };

  useEffect(() => {
    dispatch({ type: "mount" });
    return () => {
      dispatch({ type: "unmount" });
    };
  }, []);

  useEffect(() => {
    if (state.mounted) {
      getChargerInfo(state);
    }
  }, [state.mounted]);

  useEffect(() => {
    if (state.startDate && state.endDate) {
      getChargerInfo(state);
    }
  }, [state.startDate, state.endDate]);

  const handleClick = (event, value) => {
    dispatch({ type: "setDateRange", data: value });
  };

  return (
    <>
      <h2>Solar Charger Statistics</h2>
      <div className="col-12">
        <InputGroup className="mb-3">
          <InputGroup.Text>
            <Calendar />
            &nbsp;Date range:
          </InputGroup.Text>
          <DateRangePicker
            className=""
            initialSettings={{
              timePicker: true,
              timePicker24Hour: true,
              timePickerIncrement: 15,
              startDate: moment().subtract(1, "day"),
              endDate: moment(),
              locale: {
                format: "dddd Do MMM HH:mm",
              },
              ranges: {
                Today: [moment().startOf("day"), moment().endOf("day")],
                Yesterday: [
                  moment().subtract(1, "day").startOf("day"),
                  moment().subtract(1, "day").endOf("day"),
                ],
                "Last 24 Hours": [moment().subtract(1, "day"), moment()],
                "Last 7 Days": [moment().subtract(7, "day"), moment()],
                "Last 14 Days": [moment().subtract(14, "day"), moment()],
                "Last 28 Days": [moment().subtract(28, "day"), moment()],
                "This Month": [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
                "Last Month": [
                  moment().subtract(1, "month").startOf("month"),
                  moment().subtract(1, "month").endOf("month"),
                ],
              },
              showDropdowns: true,
              showCustomRangeLabel: true,
              autoApply: true,
              linkedCalendars: false,
              alwaysShowCalendars: true,
              opens: "center",
              drops: "down",
            }}
            onApply={(event, picker) => {
              handleClick(event, {
                startDate: picker.startDate,
                endDate: picker.endDate,
              });
            }}
          >
            <Form.Control />
          </DateRangePicker>
        </InputGroup>
      </div>
      {
        <>
          <div
            style={{
              display: "inline-block",
              transition: "0.5s ease",
              opacity: state.loading ? "1" : "0",
              position: "absolute",
              top: "15%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              msTransform: "translate(-50%, -50%)",
              textAlign: "center",
              zIndex: 1500,
              width: "300px",
            }}
          >
            <Card bg={"primary"} text={"white"} className="mb-2">
              <Card.Body>
                <Card.Title> Loading data ... </Card.Title>
                <Card.Text as="div">
                  <Spinner />
                </Card.Text>
              </Card.Body>
            </Card>
          </div>
          {state.data && (
            <Row
              className="pb-4"
              style={{
                transition: "ease-in 0.5s",
                opacity: state.loading ? "0.33" : "1",
              }}
            >
              {/* {graph1} */}

              <GraphWidgetContainer title="Summary">
                <SrlChargerGraphSummary
                  data={state.data}
                  sections={[
                    {
                      title: "Solar Charger",
                      codes: ["ScV", "ScI", "ScW", "SLs", "SLI", "ScS", "ScMm"],
                    },
                    {
                      title: "Battery",
                      codes: ["bv", "bc", "bp", "bst"],
                    },
                    {
                      title: "Stats",
                      codes: ["YT", "YY", "MCPT", "MCPY"],
                    },
                  ]}
                />
              </GraphWidgetContainer>
              <GraphWidgetContainer title="Solar Charger - MPPT State">
                <SrlChargerGraphTimeLine
                  params={{
                    startDate: state.startDate,
                    endDate: state.endDate,
                  }}
                  data={state.data}
                  codes={["ScS"]}
                />
              </GraphWidgetContainer>
              <GraphWidgetContainer title="Solar Charger - Voltage and Current">
                <SrlChargerGraphTimeLine
                  params={{
                    startDate: state.startDate,
                    endDate: state.endDate,
                  }}
                  data={state.data}
                  codes={["ScV", "ScI"]}
                />
              </GraphWidgetContainer>
              <GraphWidgetContainer title="Solar Charger - Load Current">
                <SrlChargerGraphTimeLine
                  params={{
                    startDate: state.startDate,
                    endDate: state.endDate,
                  }}
                  data={state.data}
                  codes={["SLI"]}
                />
              </GraphWidgetContainer>
              <GraphWidgetContainer title="Solar Charger - Yield (Battery Watts)">
                <SrlChargerGraphTimeLine
                  params={{
                    startDate: state.startDate,
                    endDate: state.endDate,
                  }}
                  data={state.data}
                  codes={["ScW"]}
                />
              </GraphWidgetContainer>
              <GraphWidgetContainer title="Battery - Voltage and Current">
                <SrlChargerGraphTimeLine
                  params={{
                    startDate: state.startDate,
                    endDate: state.endDate,
                  }}
                  data={state.data}
                  codes={["bv", "bc"]}
                />
              </GraphWidgetContainer>
            </Row>
          )}
        </>
      }
    </>
  );
};

export default SrlChargerGraphs;
